<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#download-s"></use></svg>
  Download forbrugsrapport
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>
<form [formGroup]="downloadReportFormGroup" (submit)="downloadReport()">
  <mat-dialog-content>
    <div class="form-row">
      <mat-label>Type</mat-label>
      <mat-radio-group formControlName="selectedReportType" name="reportType">
        <mat-radio-button [value]="reportType.CompanyCarAndTagsReport">
          Faktureringsrapport flåde- og firmabiler m. aftalenr.
        </mat-radio-button>
        <mat-radio-button [value]="reportType.IndividualCarReport">Faktureringrapport medarbejderbiler m. kontonr.</mat-radio-button>
        <mat-radio-button [value]="reportType.LocationReport">Lokationsrapport</mat-radio-button>
        <mat-radio-button [value]="reportType.LocationAccessGroupReport"> Lokationsrapport for adgangsgrupper </mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="form-row custom-selector-field">
      <span class="custom-selector-field__row-label">Organisationer</span>
      <button type="button" (click)="openOrganizationSelector()" class="custom-selector-field__toggle">
        <mat-icon svgIcon="business" aria-hidden="false"></mat-icon>
        <span class="custom-selector-field__input-label">Vælg organisationer</span>
        @if (organizationBadgeCount > 0) {
          <span class="custom-selector-field__chosen">
            <div matBadge="{{ organizationBadgeCount }}" matBadgeOverlap="false">Valgt</div>
          </span>
        }
        <mat-icon class="custom-selector-field__arrow" matSuffix>keyboard_arrow_down</mat-icon>
      </button>
      @if (organizationBadgeCount > 0) {
        <button class="custom-selector-field__clear-input" type="button" (click)="resetOrganizations()" aria-label="Ryd indhold i feltet">
          <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
        </button>
      }
      @if (organizationBadgeCount === 0) {
        <span class="icon-with-text orange tiny-text margin--top-s">
          <mat-icon>info</mat-icon>
          <span>Hvis der ikke vælges nogen organisationer, tages samtlige organisationer med i rapporten</span>
        </span>
      }
    </div>

    <div class="form-row mat-date-range-input">
      <mat-form-field>
        <mat-label>Periode</mat-label>
        <mat-date-range-input [rangePicker]="picker" (click)="picker.open()">
          <input formControlName="startDate" class="pointer" readonly matStartDate placeholder="Start dato" #dateRangeStart />
          <input formControlName="endDate" class="pointer" readonly matEndDate placeholder="Slut dato" #dateRangeEnd />
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div>
      <button mat-dialog-close type="button" mat-button>Annuller</button>
      <button
        type="submit"
        mat-raised-button
        color="primary"
        [disabled]="downloadReportFormGroup.invalid || loading"
        [class.spinner]="loading">
        Download rapport
      </button>
    </div>
  </mat-dialog-actions>
</form>
